import { VISIT_HISTORY } from "../../../../api/allApi_List";
import VisitHistoryDate from "./VisitHistoryDate";

function CustomDateSelector({
  historyLoaded,
  getHistory,
  closeDropDown,
  customDates,
  setCustomDates,
}) {
  const { start, end } = customDates;

  const handleDateChange = (name, value) => {
    const updatedDates = {
      ...customDates,
      [name]: value,
    };

    setCustomDates(updatedDates);

    if (updatedDates.start && updatedDates.end && !historyLoaded) {
      getHistory(`${VISIT_HISTORY}${updatedDates.start}/${updatedDates.end}`);
      closeDropDown();
    }
  };

  return (
    <div className="flex gap-1 p-1">
      <VisitHistoryDate
        label="Start *"
        name="start"
        value={start}
        onChange={(e) => handleDateChange("start", e.target.value)}
      />
      <VisitHistoryDate
        label="End *"
        name="end"
        value={end}
        onChange={(e) => handleDateChange("end", e.target.value)}
      />
    </div>
  );
}

export default CustomDateSelector;
